import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {CareersService} from '../../services/careers/careers.service';

@Component({
  selector: 'app-detail-careers',
  templateUrl: './detail-careers.component.html',
  styleUrls: ['./detail-careers.component.scss']
})
export class DetailCareersComponent implements OnInit {

    career: any;
    endpoint: any;

    constructor(
        private careersService: CareersService,
        private route: ActivatedRoute
    ) {
        const t = this;
        t.endpoint = environment.endpoint;
        if (this.route.snapshot.paramMap.get('id')) {
            this.careersService.find(this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
                t.career = data;
            });
        }
    }


    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }

    ngOnInit(): void {
    }
}
